import React, { useRef } from 'react';
import debounce from 'debounce';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import TextField from '@material-ui/core/TextField'
import FixedCostInput from './FixedCostInput';
import { all } from '../../../app/data/validate';
import DateInput from '../../../app/common/ui/DateInput';

const FixedCostLineItem = ({ tariff, subsection, category, code, quote, timesheet, onChange }) => {
    if (all(quote, timesheet)) throw new Error('quote and timesheet are mutually exclusive 🤯')

    const items = quote || timesheet;

    const service = tariff[category][subsection][code];
    const prefab = { key: service.key, category, section: subsection, code, quantity: 0 };
    const noteRef = useRef();

    if (!service) throw new Error(`category ${category} subsection ${subsection} code ${code} not found in tariff`);

    const getItem = () => {
        return items.get(service.key) || { ...prefab };
    }

    const handleCostChange = debounce(cost => {
        onChange({ ...getItem(), rate: cost, quantity: cost ? 1 : 0 });
    }, 500);

    const handleNoteChange = debounce(() => {
        onChange({ ...getItem(), note: noteRef.current.value || '' });
    }, 500)

    const handleDateChange = date => {
        onChange({ ...getItem(), date });
    }

    return (
        <Grid container item direction="row" justify="flex-start" alignItems="center" spacing={2} style={{ marginBottom: '1rem' }}>
            <Grid item xs={2}>
                <div>
                    <Typography variant="subtitle2">{service.description}</Typography>
                </div>
                <FixedCostInput item={service}
                    category={category} section={subsection} code={code}
                    value={items.get(service.key)?.rate}
                    onChange={handleCostChange} />
            </Grid>
            {
                timesheet &&
                <Grid item xs={2}>
                    <div>
                        <Typography variant="subtitle2">Date</Typography>
                    </div>
                    <DateInput value={items.get(service.key)?.date} required={items.get(service.key)?.rate > 0} hint="Date (or first date)" onChange={handleDateChange} />
                </Grid>
            }
            <Grid item xs={6}>
                <div>
                    <Typography variant="subtitle2">Notes</Typography>
                </div>
                <TextField
                    inputRef={noteRef}
                    defaultValue={items.get(service.key)?.note}
                    onChange={handleNoteChange}
                    style={{ minWidth: '100%' }}
                    helperText="Add any supporting notes (optional)"
                />
            </Grid>
        </Grid>
    );
}

export default FixedCostLineItem;